/**
 * 判断环境
 */
export function isSim() {
  return location.host.startsWith('sim');
}

export function isPre() {
  return location.host.startsWith('pre.') || location.host.startsWith('pre-');
}
